import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
      <path
        fill="var(--svg-color-main, black)"
        d="M13.065 21.122c2.544-.015 4.955-1.033 6.793-2.872l1.4 1.4c-2.21 2.21-5.115 3.435-8.185 3.449-3.027.02-5.854-1.131-7.96-3.237C1.032 15.78.936 9.234 4.901 5.269c3.654-3.653 9.503-3.749 13.04-.212 3.226 3.226 3.322 8.38.212 11.489-2.797 2.797-7.255 2.893-9.936.212-2.37-2.37-2.465-6.131-.211-8.385 1.942-1.942 5.006-2.037 6.832-.212 1.513 1.514 1.61 3.88.21 5.28-1.085 1.086-2.758 1.18-3.727.212-.599-.599-.732-1.485-.309-2.06a.99.99 0 0 1 1.779.709c.186.089.555.043.858-.26.626-.626.532-1.739-.21-2.481-.92-.919-2.723-1.099-4.034.212-1.481 1.482-1.387 3.987.212 5.585 1.91 1.91 5.111 1.814 7.137-.212 2.337-2.337 2.242-6.235-.212-8.689-2.765-2.765-7.36-2.67-10.241.212-3.194 3.193-3.098 8.483.212 11.793 1.729 1.73 4.055 2.674 6.552 2.66"
      ></path>
    </svg>
  )
}
